// EditProduct.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { refreshProductList } from "../../../redux/features/productModalSlice";
import {
  ViewProductDetail,
  UpdateProduct
} from "../../../redux/services/ProductService/product.Services";
import { successToast, errorToast } from "../../../Utils/toast";
import useDropdownData from "./CreateProductModuls/hooks/useDropdownData";
import useProductForm from "./CreateProductModuls/hooks/useProductForm";
import useProductConfiguration from "./CreateProductModuls/hooks/useProductConfiguration";
import ProductFormRenderer from "./CreateProductModuls/ProductFormRenderer";
function EditProduct({ refreshData }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const form = useProductForm();
  const dropdown = useDropdownData();
  const config = useProductConfiguration(form.formData.subcategory_slug);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(true);

  const mapAttributesToFormData = (attributes = []) => {
    const mapped = {};

    attributes.forEach((attr) => {
      if (!attr?.attr_key) return;
      let value = attr.attr_value;
      if (["color_ids", "size_ids"].includes(attr.attr_key)) {
        try {
          value = JSON.parse(attr.attr_value);
        } catch {
          value = attr.attr_value
            ? attr.attr_value.split(",").map(Number)
            : [];
        }
      }
      mapped[attr.attr_key] = value;
    });
    return mapped;
  };

  useEffect(() => {
    if (id) {
      fetchProductData(id);
    }
  }, [id]);

  const fetchProductData = async () => {
    try {
      setIsFetching(true);
      const payload = {
        id: id
      }
      const res = await ViewProductDetail(payload);
      if (res?.data?.success) {
        const productData = res.data.data;
        const attributes = mapAttributesToFormData(
          productData.attributes
        );
        form.setFormData({
          id: productData.id,
          user_id: productData.user_id,
          product_name: productData.name,
          category_id: productData.category_id,
          subcategory_id: productData.sub_category_id,
          subcategory_slug: productData.subcategory_details?.slug || "",
          brand_id: productData.brand_id,
          unit_id: productData.unit_id,
          purchase_price: productData.cost_price,
          selling_price: productData.price,
          mrp: productData.mrp,
          gst_percentage: productData.tax_percent,
          hsn_code: productData.hsn_code,
          description: productData.description,
          discount: productData.discount_percent,
          discount_type: productData.discount_type,
          sku: productData.sku || "",
          barcode: productData.barcode || "",
          status: productData.status,
          images: productData.images || [],
          variants: productData.variants || [],
          // Dynamic attributes
          ...attributes
        });
        if (productData.category_id) {
          await dropdown.loadSubCategory(productData.category_id);
        }
        if (productData.images && productData.images.length > 0) {
          form.setImagePreview(productData.images.map(img => img.image_url));
        }
      } else {
        errorToast("Failed to fetch product");
        navigate("/product-list");
      }
    } catch (error) {
      console.error("❌ Error fetching product:", error);
      errorToast("Failed to fetch product");
      navigate("/product-list");
    } finally {
      setIsFetching(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = form.validate();
    if (!isValid) {
      errorToast("Please fix validation errors");
      return;
    }

    try {
      form.setIsLoading(true);
      const payload = form.createFormData();

      const res = await UpdateProduct(id, payload);

      if (res?.data?.success) {
        successToast(res.data.message);
        refreshData?.();
        dispatch(refreshProductList());
        navigate("/product-list");
      } else {
        errorToast(res?.data?.message || "Failed to update product");
      }
    } catch (error) {
      console.log("❌ Error:", error);
      errorToast("Failed to update product");
    } finally {
      form.setIsLoading(false);
    }
  };
  const selectedUser = dropdown.users?.find(
    (user) => user.id === Number(form.formData.user_id)
  );

  if (isFetching) {
    return (
      <div className="main_page">
        <div className="text-center py-5">
          <h5>Loading product data...</h5>
        </div>
      </div>
    );
  }

  return (
    <div className="main_page">
      <div className="">
        <div className="">
          <div className="d-flex justify-content-between mb-3">
            <h4>Edit Product</h4>
            <div className="d-flex align-items-center gap-3">
              <button
                className="add-btn"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
              {/* <button className="add-btn">
                {selectedUser
                  ? `${selectedUser.name}`
                  : "Select User"}
              </button> */}
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <ProductFormRenderer
              form={form}
              users={dropdown.users}
              dropdown={dropdown}
              config={config}
            />

            <div className="col-md-12">
              <div className="d-flex justify-content-end gap-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={form.isLoading}
                >
                  {form.isLoading ? "Updating..." : "Update Product"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditProduct;